<div class="table mobile-hidden">

  <app-table-header-actions
    [exportToCsvButton]="true"
    [importTransaction]="lSService.getFeatureFlags()?.NorderCanImport"
    [addButtonName]="'Add Transaction'"
    [addButtonType]="'drop-down'"
    [actionGroupedList]="actionGroupedList"
    [dataLoaded]="dataLoaded$ | async"
    [spinner]="spinner$ | async"
    [filterValue]="filterValue"
    (applyFilter)="applyFilter($event)"
    (handleAction)="addTransaction.emit($event)"
    (exportToCsv)="exportToCsv.emit()"
    (handleImportTransaction)="importTransaction()"
  ></app-table-header-actions>

  <ng-container *ngIf="!(dataLoaded$ | async)">
    <ngx-skeleton-loader [theme]="{height: '50px', borderRadius: '5px'}"></ngx-skeleton-loader>
    <div class="skeleton-table-row" *ngFor="let item of skeletonRows">
      <ngx-skeleton-loader [theme]="{height: '16px', width: '16px', borderRadius: '200px'}"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '16px', width: '76px', borderRadius: '200px'}"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '16px', width: '76px', borderRadius: '200px'}"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '16px', width: '76px', borderRadius: '200px'}"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '16px', width: '136px', borderRadius: '200px'}"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '16px', width: '160px', borderRadius: '200px'}"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '16px', width: '76px', borderRadius: '200px'}"></ngx-skeleton-loader>
    </div>
  </ng-container>

  <ng-container *ngIf="(dataLoaded$ | async) && dataSource && dataSource.data.length">
    <div class="table-content">
      <table
        mat-table
        matSort
        multiTemplateDataRows
        matSortActive="date"
        matSortDirection="desc"
        [dataSource]="dataSource"
        class="transaction-table"
      >
        <ng-container matColumnDef="{{ column }}" *ngFor="let column of columns">
          <ng-container *ngIf="column === 'dropDown'; else primaryColumn">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <div class="image"></div>
            </td>
          </ng-container>

          <ng-container *ngIf="column === 'date'; else primaryColumn">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              <p> {{ getColumnName(column) }} </p>
            </th>
            <td mat-cell *matCellDef="let element">
              <p>
                {{ element[column] | date: 'd MMM, y' }}
              </p>
            </td>
          </ng-container>

          <ng-container *ngIf="column === 'direction'; else primaryColumn">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              {{ getColumnName(column) }}
            </th>
            <td mat-cell *matCellDef="let element">
              <app-chip
                *ngIf="element[column]"
                [label]="element.type === 'Invoice' ? element.invoice?.status : element[column]"
              ></app-chip>
            </td>
          </ng-container>

          <ng-container *ngIf="column === 'account'; else primaryColumn">
            <th mat-header-cell *matHeaderCellDef>
              {{ getColumnName(column) }}
            </th>
            <td mat-cell *matCellDef="let element">
              <p appEllipsisTooltip>
                {{ element[column].displayName }}
              </p>
            </td>
          </ng-container>

          <ng-container *ngIf="column === 'amount'; else primaryColumn">
            <th class="amount-column" mat-header-cell mat-sort-header *matHeaderCellDef>
              {{ getColumnName(column) }}
            </th>
            <td mat-cell *matCellDef="let element">
              ${{ element[column] | number: '0.2-2' }}
            </td>
          </ng-container>

          <ng-container *ngIf="column === 'more'; else primaryColumn">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <app-table-row-actions
                [actions]="actions"
                (handleAction)="handleAction.emit([element, $event])"
              ></app-table-row-actions>
            </td>
          </ng-container>

          <ng-container *ngIf="column === 'type'; else primaryColumn">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              {{ getColumnName(column) }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element[column] === 'Manualledger' ? 'Manual Ledger' : element[column] }}
            </td>
          </ng-container>

          <ng-template #primaryColumn>
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              {{ getColumnName(column) }}
            </th>
            <td mat-cell *matCellDef="let element">
              <p appEllipsisTooltip>
                {{ element[column] }}
              </p>
            </td>
          </ng-template>
        </ng-container>

        <!-- Expanded Content Column -->
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="columns.length" [class.expanded]="element == expandedElement">
            <div class="nested-table-wrapper"
                 [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
            >
              <app-nested-table
                class="nested-table"
                [transaction]="element"
                [columnsData]="nestedTableColumnsData"
              ></app-nested-table>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns" [class.hidden]="!(dataLoaded$ | async)"></tr>
        <tr
          mat-row
          class="element-row"
          *matRowDef="let element; columns: columns;"
          [class.border-hidden]="!(dataLoaded$ | async)"
          [class.expanded-row]="expandedElement === element"
          (click)="rowClick(element)">
          >
        </tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row" [class.detail-expanded-row]="row.showNestedTable"></tr>
      </table>
    </div>
  </ng-container>

  <mat-paginator
    [class.hidden]="!dataSource || (dataSource && dataSource.data.length <= pageSize)"
    [pageSize]="pageSize"
  ></mat-paginator>

  <ng-container *ngIf="(dataLoaded$ | async) && dataSource && !dataSource.data.length">
    <app-empty-content
      [emptyContentData]="emptyContentTransaction"
    ></app-empty-content>
  </ng-container>

</div>
